export class CustomizationOption {
  name: string;
  overlayImageUrl: string;
  thumbnailImageUrl: string;
  additionalCost: number;
}
